export default function SvgShape() {
	return (
		<svg
			className="!absolute top-0 right-0 z-0"
			style={{
				transform: "translate(44vw, -15vw) scale(1.2) rotateZ(-5deg)",
			}}
			id="sw-js-blob-svg"
			viewBox="0 0 110 110"
			xmlns="http://www.w3.org/2000/svg"
		>
			{" "}
			<defs>
				{" "}
				<linearGradient id="sw-gradient" x1="0" x2="1" y1="1" y2="0">
					{" "}
					<stop
						id="stop1"
						stopColor="rgba(248, 117, 55, 1)"
						offset="0%"
					></stop>{" "}
					<stop
						id="stop2"
						stopColor="rgba(251, 168, 31, 1)"
						offset="100%"
					></stop>{" "}
				</linearGradient>{" "}
			</defs>{" "}
			<path
				fill="url(#sw-gradient)"
				d="M21.1,-37C27.3,-33.1,32.1,-27.2,33.9,-20.7C35.8,-14.2,34.8,-7.1,34.3,-0.3C33.8,6.5,33.9,13.1,30.7,17.3C27.5,21.5,21,23.3,15.4,27.1C9.7,30.9,4.8,36.6,1.1,34.7C-2.7,32.8,-5.4,23.4,-7,17.3C-8.7,11.2,-9.3,8.5,-14.1,6.2C-18.9,3.8,-27.9,1.9,-32.1,-2.4C-36.2,-6.7,-35.6,-13.5,-33,-19.6C-30.4,-25.8,-25.9,-31.4,-20.1,-35.5C-14.2,-39.6,-7.1,-42.2,0.2,-42.5C7.5,-42.8,15,-40.9,21.1,-37Z"
				width="100%"
				height="100%"
				transform="translate(50 50)"
				strokeWidth="0"
			></path>
		</svg>
	);
}